export default window._cmsContent['whd/completed']